module.exports = __webpack_public_path__ + "static/media/icon_comments.47dbac0b.svg";